import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getDatabase, ref, onValue } from "firebase/database";
import Navbar1 from "./Navbar";
import Footer1 from "./Footer";
import {
  FaMapMarkerAlt,
  FaTimes,
  FaStar,
  FaPlane,
  FaBus,
  FaHotel,
  FaUtensils,
  FaMonument,
  FaCalendarAlt,
  FaFilePdf,
} from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import { jsPDF } from "jspdf";
import logo from "../../assets/logo.png"; // Make sure to have your logo in the correct path

const AgentPackagesPage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const navigate = useNavigate();
  const modalRef = useRef(null);

  // useEffect(() => {
  //   const fetchPackages = async () => {
  //     try {
  //       const database = getDatabase();
  //       const packagesRef = ref(database, 'AgentPackages');

  //       onValue(packagesRef, (snapshot) => {
  //         const data = snapshot.val();
  //         if (data) {
  //           const formattedPackages = [];

  //           ['domestic', 'international'].forEach((packageType) => {
  //             if (data[packageType]) {
  //               Object.entries(data[packageType]).forEach(([destination, destinationPackages]) => {
  //                 Object.entries(destinationPackages).forEach(([packageName, pkg]) => {
  //                   if (packageName === 'MarkupPrices') return;

  //                   const hasMarkupPrice = pkg.MarkupPrices && pkg.MarkupPrices.finalPrice !== undefined;
  //                   const price = hasMarkupPrice ? pkg.MarkupPrices.finalPrice : null;
  //                   const originalPrice = pkg.originalPrice || pkg.price;
  //                   const discountAmount = price ? (originalPrice - price) : 0;
  //                   const hasDiscount = discountAmount > 0;

  //                   if (hasMarkupPrice) {
  //                     formattedPackages.push({
  //                       key: `${packageType}-${destination}-${packageName}`,
  //                       name: pkg.name || packageName,
  //                       destination,
  //                       type: packageType,
  //                       duration: pkg.duration || 'Not specified',
  //                       price: price,
  //                       originalPrice: originalPrice,
  //                       discountAmount: discountAmount,
  //                       hasDiscount: hasDiscount,
  //                       status: pkg.MarkupPrices?.status || 'No markup',
  //                       lastUpdated: pkg.lastUpdated || 'N/A',
  //                       imageUrl: pkg.imageUrl || 'https://via.placeholder.com/300x200?text=No+Image',
  //                       images: pkg.images || [],
  //                       fullData: pkg,
  //                       nights: parseInt(pkg.duration?.match(/\d+N/)?.[0]) || 4,
  //                       days: parseInt(pkg.duration?.match(/\d+N/)?.[0]) + 1 || 5
  //                     });
  //                   }
  //                 });
  //               });
  //             }
  //           });

  //           setPackages(formattedPackages);
  //         }
  //         setLoading(false);
  //       });
  //     } catch (error) {
  //       console.error('Error fetching packages:', error);
  //       setLoading(false);
  //     }
  //   };

  //   fetchPackages();
  // }, []);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const database = getDatabase();
        const packagesRef = ref(database, "AgentPackages");

        onValue(packagesRef, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            const formattedPackages = [];

            ["domestic", "international"].forEach((packageType) => {
              if (data[packageType]) {
                Object.entries(data[packageType]).forEach(
                  ([destination, destinationPackages]) => {
                    Object.entries(destinationPackages).forEach(
                      ([packageName, pkg]) => {
                        if (packageName === "MarkupPrices") return;

                        // Check for both old and new markup data structures
                        const markupData = pkg.MarkupPrices;
                        const hasNewMarkupFormat =
                          markupData?.originalPricesWithText !== undefined;
                        const hasOldMarkupFormat =
                          markupData?.finalPrice !== undefined;

                        // Get price information based on format
                        let price, originalPrice;
                        if (hasNewMarkupFormat) {
                          // New format with originalPricesWithText
                          const firstPriceKey = Object.keys(
                            markupData.originalPricesWithText
                          )[0];
                          originalPrice =
                            markupData.originalPricesWithText[firstPriceKey];
                          price = markupData.finalPrices[firstPriceKey];
                        } else if (hasOldMarkupFormat) {
                          // Old format
                          originalPrice =
                            markupData.originalPriceWithText ||
                            pkg.originalPrice ||
                            pkg.price;
                          price = markupData.finalPrice;
                        } else {
                          // No markup
                          originalPrice = pkg.originalPrice || pkg.price;
                          price = originalPrice;
                        }

                        const discountAmount =
                          price && originalPrice
                            ? parseInt(
                                String(originalPrice).replace(/\D/g, "")
                              ) - parseInt(String(price).replace(/\D/g, ""))
                            : 0;
                        const hasDiscount = discountAmount > 0;

                        if (hasNewMarkupFormat || hasOldMarkupFormat) {
                          formattedPackages.push({
                            key: `${packageType}-${destination}-${packageName}`,
                            name: pkg.name || packageName,
                            destination,
                            type: packageType,
                            duration: pkg.duration || "Not specified",
                            price: price,
                            originalPrice: originalPrice,
                            discountAmount: discountAmount,
                            hasDiscount: hasDiscount,
                            status: markupData?.status || "No markup",
                            lastUpdated: pkg.lastUpdated || "N/A",
                            imageUrl:
                              pkg.imageUrl ||
                              "https://via.placeholder.com/300x200?text=No+Image",
                            images: pkg.images || [],
                            fullData: pkg,
                            nights:
                              parseInt(pkg.duration?.match(/\d+N/)?.[0]) || 4,
                            days:
                              parseInt(pkg.duration?.match(/\d+N/)?.[0]) + 1 ||
                              5,
                          });
                        }
                      }
                    );
                  }
                );
              }
            });

            setPackages(formattedPackages);
          }
          setLoading(false);
        });
      } catch (error) {
        console.error("Error fetching packages:", error);
        setLoading(false);
      }
    };

    fetchPackages();
  }, []);

  const showPackageDetails = (pkg) => {
    setSelectedPackage(pkg);
    setShowModal(true);
    setImageLoading(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedPackage(null);
  };

  const getPackageTypeColor = (type) => {
    return type === "domestic" ? "#2563eb" : "#4f46e5";
  };

  const generatePDF = async () => {
    if (!selectedPackage) return;

    try {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      let yPosition = 10;

      // Add logo
      const img = new Image();
      img.src = logo;
      await new Promise((resolve) => (img.onload = resolve));

      const logoWidth = 30;
      const logoHeight = 30;
      const centerX = 105 - logoWidth / 2;
      doc.addImage(img, "PNG", centerX, yPosition, logoWidth, logoHeight);
      yPosition += logoHeight + 5;

      // Add company info
      doc.setFontSize(22);
      doc.setTextColor(40, 40, 40);
      doc.setFont("helvetica", "bold");
      doc.text("Pearl Tours & Travels", 105, yPosition, { align: "center" });
      yPosition += 10;

      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.setFont("helvetica", "normal");
      doc.text(
        "Address: Pearl Enclave, MSEB Rd, next to Chai Sutta Bar,",
        105,
        yPosition,
        { align: "center" }
      );
      yPosition += 5;
      doc.text(
        "Viya Nagar, Vishrambag, Sangli, Maharashtra 416415",
        105,
        yPosition,
        { align: "center" }
      );
      yPosition += 5;
      doc.text(
        "Mobile: +91-73034 55505 | Email: pearltoursandtravelsangli@gmail.com",
        105,
        yPosition,
        { align: "center" }
      );
      yPosition += 15;

      // Add title
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("TOUR PACKAGE DETAILS", 105, yPosition, { align: "center" });
      yPosition += 15;

      // Add divider
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(20, yPosition, 190, yPosition);
      yPosition += 10;

      // Add package name
      doc.setFontSize(18);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text(`${selectedPackage.name.toUpperCase()}`, 20, yPosition);
      yPosition += 10;

      // Add package details
      doc.setFontSize(12);
      doc.setTextColor(80, 80, 80);
      doc.setFont("helvetica", "normal");
      doc.text(`Destination: ${selectedPackage.destination}`, 20, yPosition);
      yPosition += 7;
      doc.text(`Duration: ${selectedPackage.duration}`, 20, yPosition);
      yPosition += 7;



// Check for multiple prices in originalPricesWithText
const markupData = selectedPackage.fullData?.MarkupPrices;
if (markupData?.originalPricesWithText) {
    // Price section header
    doc.setFontSize(14);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("PRICING OPTIONS:", 20, yPosition);
    yPosition += 10;

    doc.setFontSize(12);
    
    // Display each price variant
    Object.entries(markupData.originalPricesWithText).forEach(([priceKey, originalPrice]) => {
        if (yPosition > 267) {  // Check if we need a new page
            doc.addPage();
            yPosition = 20;
        }
        
        const finalPrice = markupData.finalPrices?.[priceKey] || originalPrice;
        
        // Price type label
        doc.setTextColor(30, 58, 138);
        doc.setFont("helvetica", "bold");
        doc.text(`${priceKey}:`, 20, yPosition);
        
        // Original Price
        doc.setTextColor(100, 100, 100);
        doc.setFont("helvetica", "normal");
        doc.text(originalPrice, 60, yPosition);
        
        // Draw strikethrough line manually
        const textWidth = doc.getTextWidth(originalPrice);
        doc.line(60, yPosition + 1, 60 + textWidth, yPosition + 1);
        
        // // Final Price
        // doc.setTextColor(5, 150, 105); // Green color
        // doc.setFont("helvetica", "bold");
        // doc.text(finalPrice, 100, yPosition);
        
        // Savings calculation if numeric values available
        if (markupData.numericOriginalPrices?.[priceKey]) {
            const originalNumeric = markupData.numericOriginalPrices[priceKey];
            const finalNumeric = parseInt(String(finalPrice).replace(/\D/g, "")) || originalNumeric;
            const savings = originalNumeric - finalNumeric;
            
            if (savings > 0) {
                doc.setFontSize(10);
                doc.setTextColor(220, 38, 38); // Red color
                doc.text(`(Save ₹${savings.toLocaleString("en-IN")})`, 140, yPosition);
                doc.setFontSize(12);
            }
        }
        yPosition += 10;
    });
} else {
    // Single price fallback
    if (yPosition > 267) {  // Check if we need a new page
        doc.addPage();
        yPosition = 20;
    }
    
    doc.text(`Price: ₹${selectedPackage.price?.toLocaleString("en-IN") || "0"}`, 20, yPosition);
    yPosition += 7;
    
    // Show original price and savings if available
    if (selectedPackage.originalPrice && selectedPackage.originalPrice !== selectedPackage.price) {
        doc.setTextColor(100, 100, 100);
        doc.text(`Original Price: ${selectedPackage.originalPrice}`, 20, yPosition);
        
        // Draw strikethrough line manually
        const textWidth = doc.getTextWidth(selectedPackage.originalPrice);
        doc.line(20, yPosition + 1, 20 + textWidth, yPosition + 1);
        yPosition += 7;
        
        doc.setTextColor(5, 150, 105); // Green color
        doc.setFont("helvetica", "bold");
        doc.text(`Our Price: ${selectedPackage.price}`, 20, yPosition);
        
        // Calculate savings
        const originalNumeric = parseInt(String(selectedPackage.originalPrice).replace(/\D/g, "")) || 0;
        const finalNumeric = parseInt(String(selectedPackage.price).replace(/\D/g, "")) || 0;
        const savings = originalNumeric - finalNumeric;
        
        if (savings > 0) {
            doc.setFontSize(10);
            doc.setTextColor(220, 38, 38); // Red color
            doc.text(`(Save ₹${savings.toLocaleString("en-IN")})`, 70, yPosition);
            doc.setFontSize(12);
        }
        yPosition += 10;
    }
}
yPosition += 15;



      // Add description
      doc.setFontSize(14);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("DESCRIPTION", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setTextColor(50, 50, 50);
      const description =
        selectedPackage.fullData?.description || "No description available";
      const descriptionLines = doc.splitTextToSize(description, 170);
      descriptionLines.forEach((line) => {
        if (yPosition > 267) {
          doc.addPage();
          yPosition = 20;
        }
        doc.text(line, 20, yPosition);
        yPosition += 6;
      });
      yPosition += 10;

      // Add itinerary
      doc.addPage();
      yPosition = 20;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("DETAILED ITINERARY", 105, yPosition, { align: "center" });
      yPosition += 10;

      if (selectedPackage.fullData?.itinerary) {
        Object.entries(selectedPackage.fullData.itinerary).forEach(
          ([dayTitle, activities], index) => {
            if (yPosition > 267) {
              doc.addPage();
              yPosition = 20;
            }

            doc.setFillColor(241, 243, 245);
            doc.rect(15, yPosition, 180, 8, "F");
            doc.setFontSize(14);
            doc.setTextColor(30, 58, 138);
            doc.text(dayTitle, 20, yPosition + 6);
            yPosition += 10;

            yPosition += 5;

            doc.setFontSize(12);
            doc.setTextColor(50, 50, 50);
            const descText =
              typeof activities === "object"
                ? activities.description || ""
                : activities;
            const descLines = doc.splitTextToSize(descText, 170);
            descLines.forEach((line) => {
              if (yPosition > 267) {
                doc.addPage();
                yPosition = 20;
              }
              doc.text(line, 20, yPosition);
              yPosition += 6;
            });
            yPosition += 5;
          }
        );
      } else {
        doc.text("No detailed itinerary available.", 20, yPosition);
        yPosition += 10;
      }

      // Add inclusions
      doc.addPage();
      yPosition = 20;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("INCLUSIONS", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      if (selectedPackage.fullData?.inclusions) {
        const inclusions = selectedPackage.fullData.inclusions.split("\n");
        inclusions.forEach((item) => {
          if (yPosition > 267) {
            doc.addPage();
            yPosition = 20;
          }
          doc.text(`• ${item}`, 25, yPosition);
          yPosition += 7;
        });
      } else {
        doc.text("No inclusions listed.", 25, yPosition);
        yPosition += 7;
      }

      // Add exclusions
      yPosition += 10;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("EXCLUSIONS", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      if (selectedPackage.fullData?.exclusions) {
        const exclusions = selectedPackage.fullData.exclusions.split("\n");
        exclusions.forEach((item) => {
          if (yPosition > 267) {
            doc.addPage();
            yPosition = 20;
          }
          doc.text(`• ${item}`, 25, yPosition);
          yPosition += 7;
        });
      } else {
        doc.text("No exclusions listed.", 25, yPosition);
        yPosition += 7;
      }

      // Add footer to all pages
      const pageCount = doc.internal.getNumberOfPages();
      const footerY = 287;
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.3);
        doc.line(15, footerY - 5, 195, footerY - 5);
        doc.setFontSize(10);
        doc.setTextColor(100, 100, 100);
        doc.text(`Page ${i} of ${pageCount}`, 105, footerY, {
          align: "center",
        });
        doc.text("Pearl Tours & Travels", 20, footerY);
        doc.text(new Date().toLocaleDateString(), 190, footerY, {
          align: "right",
        });
      }

      // Save the PDF
      const fileName = `${(selectedPackage.name || "tour").replace(
        /\s+/g,
        "_"
      )}_package_details.pdf`;
      doc.save(fileName);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  if (loading) {
    return (
      <>
        <Navbar1 />
<div>
      <style>{`
        .loading-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(135deg, #7d0000ff 0%, #ab0404ff 100%);
          color: #fff;
          z-index: 9999;
          flex-direction: column;
        }

        .loader {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
        }

        .loader-spinner {
          width: 80px;
          height: 80px;
          border: 8px solid rgba(255, 255, 255, 0.2);
          border-top: 8px solid #fff;
          border-radius: 50%;
          animation: spin 1.2s linear infinite;
        }

        .loader-spinner-inner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(255, 255, 255, 0.2);
          border-top: 4px solid #ffeb3b;
          border-radius: 50%;
          margin: auto;
          margin-top: 14px;
          animation: spin-reverse 1.5s linear infinite;
        }

        .loader-text {
          font-size: 1.4rem;
          font-weight: bold;
          letter-spacing: 1px;
          margin-top: 10px;
        }

        .loader-dots {
          display: flex;
          gap: 6px;
          margin-top: 5px;
        }

        .dot {
          width: 10px;
          height: 10px;
          background: #fff;
          border-radius: 50%;
          animation: bounce 1.2s infinite ease-in-out;
        }

        .dot:nth-child(1) {
          animation-delay: 0s;
        }

        .dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes spin-reverse {
          0% { transform: rotate(360deg); }
          100% { transform: rotate(0deg); }
        }

        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0.8);
            opacity: 0.6;
          }
          40% {
            transform: scale(1.2);
            opacity: 1;
          }
        }
      `}</style>

      <div className="loading-container">
        <div className="loader">
          <div className="loader-spinner">
            <div className="loader-spinner-inner"></div>
          </div>
          <div className="loader-text">Loading Packages</div>
          <div className="loader-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </div>

    

      </>
    );
  }

  return (
    <>
      <Navbar1 />
      <div className="departure-page">
        <header className="page-header">
          <div className="header-content">
            <h1>
              Agent <span>Packages</span>
            </h1>
            <p>Manage and view all available tour packages</p>
            <div className="header-decoration">
              <div className="decoration-line"></div>
              <div className="decoration-dot"></div>
              <div className="decoration-line"></div>
            </div>
          </div>
        </header>

        <div className="tour-grid-container">
          <div className="tour-grid">
            {packages.map((pkg) => (
              <div key={pkg.key} className="tour-card">
                <div className="card-image-container">
                  <img src={pkg.images} alt={pkg.name} />
                  <div className="image-overlay">
                    <span className="tour-duration">
                      {pkg.days} Days / {pkg.nights} Nights
                    </span>
                    <div className="rating-badge">
                      <FaStar className="star-icon" />
                      <span>5.0</span>
                    </div>
                  </div>
                </div>

                <div className="card-content">
                  <div className="tour-header">
                    <h3>{pkg.name}</h3>
                    <div className="tour-destination">
                      <FaMapMarkerAlt className="icon" />
                      <span>{pkg.destination}</span>
                      <span
                        className="package-type"
                        style={{
                          backgroundColor: getPackageTypeColor(pkg.type),
                        }}
                      >
                        {pkg.type.charAt(0).toUpperCase() + pkg.type.slice(1)}
                      </span>
                    </div>
                  </div>

                  <div className="price-section">
                    {pkg.hasDiscount && (
                      <div className="original-price">
                        <s>₹{pkg.originalPrice?.toLocaleString("en-IN")}</s>
                        <span className="discount-badge">
                          SAVE ₹{pkg.discountAmount?.toLocaleString("en-IN")}
                        </span>
                      </div>
                    )}
                    <div className="discounted-price">
                      ₹{pkg.price?.toLocaleString("en-IN")}
                    </div>
                  </div>

                  <div className="card-footer">
                    <button
                      className="details-btn"
                      onClick={() => showPackageDetails(pkg)}
                    >
                      View Details <FiChevronRight className="arrow-icon" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {showModal && selectedPackage && (
          <div className="modal-overlay">
            <div className="modal-container" ref={modalRef}>
              <button className="close-modal" onClick={handleModalClose}>
                <FaTimes />
              </button>

              <div className="modal-header">
                <div className="modal-image-container">
                  <img
                    src={selectedPackage.images}
                    alt={selectedPackage.name}
                  />
                </div>
                <div className="modal-title">
                  <h2>{selectedPackage.name}</h2>
                  <div className="tour-meta">
                    <span>
                      <FaMapMarkerAlt /> {selectedPackage.destination}
                    </span>
                    <span>
                      <FaCalendarAlt /> {selectedPackage.days} Days /{" "}
                      {selectedPackage.nights} Nights
                    </span>
                    <span
                      className="package-type"
                      style={{
                        backgroundColor: getPackageTypeColor(
                          selectedPackage.type
                        ),
                      }}
                    >
                      {selectedPackage.type.charAt(0).toUpperCase() +
                        selectedPackage.type.slice(1)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="modal-content">
                <div className="price-section">
                  {selectedPackage.hasDiscount && (
                    <div className="original-price">
                      <span>
                        Original Price: ₹
                        {selectedPackage.originalPrice?.toLocaleString("en-IN")}
                      </span>
                      <span className="discount-badge">
                        SAVE ₹
                        {selectedPackage.discountAmount?.toLocaleString(
                          "en-IN"
                        )}
                      </span>
                    </div>
                  )}
                  <div className="discounted-price">
                    <span>
                      Special Price: ₹
                      {selectedPackage.price?.toLocaleString("en-IN")}
                    </span>
                  </div>
                </div>

                {selectedPackage.fullData?.description && (
                  <div className="section">
                    <h3>Package Description</h3>
                    <p>{selectedPackage.fullData.description}</p>
                  </div>
                )}

                {selectedPackage.images &&
                  selectedPackage.images.length > 0 && (
                    <div className="section">
                      <h3>Gallery</h3>
                      <div className="gallery-grid">
                        {selectedPackage.images.map((img, index) => (
                          <div key={index} className="gallery-item">
                            <img
                              src={img}
                              alt={`${selectedPackage.name} ${index + 1}`}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {selectedPackage.fullData?.inclusions && (
                  <div className="features-grid">
                    <div className="features-section">
                      <h3>What's Included</h3>
                      <ul>
                        {selectedPackage.fullData.inclusions
                          .split("\n")
                          .map((item, index) => (
                            <li key={index}>
                              <FaStar className="icon" /> {item}
                            </li>
                          ))}
                      </ul>
                    </div>

                    {selectedPackage.fullData?.exclusions && (
                      <div className="features-section">
                        <h3>What's Not Included</h3>
                        <ul>
                          {selectedPackage.fullData.exclusions
                            .split("\n")
                            .map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}

                {selectedPackage.fullData?.itinerary && (
                  <div className="section">
                    <h3>Tour Itinerary</h3>
                    <div className="itinerary-list">
                      {Object.entries(selectedPackage.fullData.itinerary).map(
                        ([day, activities], index) => (
                          <div key={index} className="itinerary-day">
                            <h4>
                              Day {day}: {activities.title || "Day Activities"}
                            </h4>
                            <p>{activities.description || activities}</p>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}

                <div className="modal-actions">
                  <button className="pdf-btn" onClick={generatePDF}>
                    <FaFilePdf /> Download PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer1 />

      <style jsx>{`
        /* Modern Design Styles */
        :root {
          --primary-color: #2563eb;
          --primary-dark: #1e40af;
          --secondary-color: #f59e0b;
          --secondary-dark: #d97706;
          --accent-color: #4f46e5;
          --light-bg: #f8fafc;
          --dark-text: #1e293b;
          --light-text: #ffffff;
          --gray-text: #64748b;
          --card-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -2px rgba(0, 0, 0, 0.05);
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          --border-radius: 12px;
          --error-color: #e74c3c;
        }





















        .departure-page {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 20px 60px;
          font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
          background-color: var(--light-bg);
        }

        .page-header {
          text-align: center;
          margin-bottom: 60px;
          padding: 60px 0 40px;
          position: relative;
          background: linear-gradient(135deg, #f0f4ff 0%, #f8fafc 100%);
          border-radius: 0 0 var(--border-radius) var(--border-radius);
          overflow: hidden;
        }

        .page-header::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(
            90deg,
            var(--primary-color),
            var(--secondary-color)
          );
        }

        .header-content {
          max-width: 800px;
          margin: 0 auto;
          position: relative;
        }

        .page-header h1 {
          font-size: 3rem;
          font-weight: 800;
          color: var(--dark-text);
          margin-bottom: 16px;
          line-height: 1.2;
        }

        .page-header h1 span {
          color: var(--primary-color);
          position: relative;
        }

        .page-header h1 span::after {
          content: "";
          position: absolute;
          bottom: 5px;
          left: 0;
          right: 0;
          height: 8px;
          background-color: rgba(37, 99, 235, 0.2);
          z-index: -1;
        }

        .page-header p {
          font-size: 1.1rem;
          color: var(--gray-text);
          max-width: 600px;
          margin: 0 auto 24px;
          line-height: 1.6;
        }

        .header-decoration {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-top: 24px;
        }

        .decoration-line {
          width: 40px;
          height: 2px;
          background-color: var(--primary-color);
          opacity: 0.5;
        }

        .decoration-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: var(--secondary-color);
        }

        .tour-grid-container {
          padding: 0 20px;
        }

        .tour-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
          gap: 30px;
          padding: 0;
        }

        .tour-card {
          background: white;
          border-radius: var(--border-radius);
          overflow: hidden;
          box-shadow: var(--card-shadow);
          transition: var(--transition);
          position: relative;
          display: flex;
          flex-direction: column;
        }

        .tour-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
            0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }

        .card-image-container {
          position: relative;
          height: 220px;
          overflow: hidden;
        }

        .card-image-container img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .tour-card:hover .card-image-container img {
          transform: scale(1.05);
        }

        .image-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
          padding: 16px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
        }

        .tour-duration {
          background: rgba(0, 0, 0, 0.7);
          color: white;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 500;
        }

        .rating-badge {
          display: flex;
          align-items: center;
          background-color: rgba(255, 255, 255, 0.9);
          padding: 4px 8px;
          border-radius: 20px;
          color: var(--dark-text);
          font-size: 0.8rem;
          font-weight: 600;
        }

        .rating-badge .star-icon {
          color: var(--secondary-color);
          margin-right: 4px;
          font-size: 0.7rem;
        }

        .card-content {
          padding: 24px;
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .tour-header {
          margin-bottom: 16px;
        }

        .tour-header h3 {
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--dark-text);
          margin-bottom: 8px;
          line-height: 1.3;
        }

        .tour-destination {
          display: flex;
          align-items: center;
          color: var(--gray-text);
          font-size: 0.9rem;
          gap: 8px;
          flex-wrap: wrap;
        }

        .tour-destination .icon {
          color: var(--primary-color);
          font-size: 0.8rem;
        }

        .package-type {
          color: white;
          font-size: 0.7rem;
          font-weight: 600;
          padding: 2px 8px;
          border-radius: 4px;
          text-transform: uppercase;
        }

        .price-section {
          margin: 16px 0;
        }

        .original-price {
          text-decoration: line-through;
          color: var(--gray-text);
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 4px;
        }

        .discount-badge {
          background-color: var(--secondary-color);
          color: white;
          font-size: 0.7rem;
          font-weight: 600;
          padding: 2px 8px;
          border-radius: 4px;
        }

        .discounted-price {
          font-size: 1.5rem;
          font-weight: 800;
          color: var(--primary-color);
          display: flex;
          align-items: flex-end;
          gap: 8px;
        }

        .price-label {
          font-size: 0.8rem;
          color: var(--gray-text);
          font-weight: 400;
          margin-bottom: 2px;
        }

        .card-footer {
          margin-top: auto;
          display: flex;
          gap: 8px;
        }

        .details-btn {
          flex: 1;
          padding: 12px;
          background-color: var(--primary-color);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 0.9rem;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .details-btn:hover {
          background-color: var(--primary-dark);
          transform: translateY(-2px);
        }

        .edit-btn {
          flex: 1;
          padding: 12px;
          background-color: white;
          color: var(--primary-color);
          border: 1px solid var(--primary-color);
          border-radius: 6px;
          font-size: 0.9rem;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .edit-btn:hover {
          background-color: #f0f4ff;
          transform: translateY(-2px);
        }

        .details-btn .arrow-icon {
          transition: transform 0.3s ease;
        }

        .details-btn:hover .arrow-icon {
          transform: translateX(3px);
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
          overflow-y: auto;
        }

        .modal-container {
          background: white;
          border-radius: 10px;
          max-width: 900px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
          position: relative;
          animation: modalFadeIn 0.3s ease;
        }

        @keyframes modalFadeIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .close-modal {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 1.5rem;
          color: #777;
          cursor: pointer;
          z-index: 10;
          transition: var(--transition);
        }

        .close-modal:hover {
          color: var(--primary-color);
          transform: rotate(90deg);
        }

        .modal-header {
          position: relative;
        }

        .modal-image-container {
          height: 300px;
          overflow: hidden;
        }

        .modal-image-container img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .modal-title {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 20px;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
          color: white;
        }

        .modal-title h2 {
          margin: 0;
          font-size: 1.8rem;
          color: white;
        }

        .tour-meta {
          display: flex;
          gap: 20px;
          margin-top: 10px;
          font-size: 0.9rem;
          flex-wrap: wrap;
        }

        .tour-meta span {
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .modal-content {
          padding: 30px;
        }

        .price-section {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 30px;
          text-align: center;
        }

        .original-price {
          text-decoration: line-through;
          color: #777;
          margin-bottom: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }

        .discount-badge {
          background: var(--secondary-color);
          color: white;
          padding: 3px 10px;
          border-radius: 20px;
          font-size: 0.8rem;
        }

        .discounted-price {
          font-size: 1.8rem;
          font-weight: bold;
          color: var(--primary-color);
          margin-top: 5px;
        }

        .price-label {
          font-size: 0.9rem;
          color: #777;
          margin-left: 5px;
          font-weight: normal;
        }

        .section {
          margin-bottom: 30px;
        }

        .section h3 {
          color: var(--primary-color);
          margin-bottom: 15px;
          padding-bottom: 5px;
          border-bottom: 2px solid #eee;
        }

        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 15px;
        }

        .gallery-item {
          height: 100px;
          overflow: hidden;
          border-radius: 8px;
        }

        .gallery-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .features-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
          margin: 30px 0;
        }

        .features-section h3 {
          color: var(--primary-color);
          margin-bottom: 15px;
        }

        .features-section ul {
          list-style: none;
          padding: 0;
        }

        .features-section li {
          margin-bottom: 10px;
          display: flex;
          align-items: flex-start;
          gap: 10px;
        }

        .features-section .icon {
          color: var(--secondary-color);
          margin-top: 3px;
        }

        .itinerary-list {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .itinerary-day {
          background: #f8f9fa;
          padding: 15px;
          border-radius: 8px;
        }

        .itinerary-day h4 {
          color: var(--primary-color);
          margin-bottom: 10px;
        }

        .itinerary-day p {
          margin: 0;
        }

        .modal-actions {
          display: flex;
          justify-content: flex-end;
          padding: 20px 0;
          margin-top: 20px;
          border-top: 1px solid #eee;
        }

        .pdf-btn {
          background-color: var(--error-color);
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          font-size: 0.9rem;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .pdf-btn:hover {
          background-color: #c0392b;
          transform: translateY(-2px);
        }

        /* Loading and Error States */
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 60vh;
        }

        .spinner {
          border: 5px solid #f3f3f3;
          border-top: 5px solid var(--primary-color);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
          margin-bottom: 20px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Responsive Styles */
        @media (max-width: 1024px) {
          .tour-grid {
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          }

          .features-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 768px) {
          .page-header {
            padding: 40px 0 30px;
          }

          .page-header h1 {
            font-size: 2.2rem;
          }

          .page-header p {
            font-size: 1rem;
          }

          .modal-title h2 {
            font-size: 1.5rem;
          }

          .tour-meta {
            flex-direction: column;
            gap: 5px;
          }
        }

        @media (max-width: 480px) {
          .departure-page {
            padding: 0 15px 40px;
          }

          .page-header h1 {
            font-size: 1.8rem;
          }

          .tour-grid {
            grid-template-columns: 1fr;
          }

          .card-image-container {
            height: 200px;
          }

          .modal-image-container {
            height: 200px;
          }

          .modal-content {
            padding: 20px;
          }

          .gallery-grid {
            grid-template-columns: 1fr 1fr;
          }

          .card-footer {
            flex-direction: column;
          }

          .details-btn,
          .edit-btn {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default AgentPackagesPage;
